
import {defineComponent, ref} from "vue";
export default defineComponent({
  name: 'MovieRating',
  props: {
    rating: {
      type: Number,
      required: true,
      default: 0
    }
  },
  setup (props) {
    const isFullNumber = Number.isInteger(props.rating);
    const rating = isFullNumber ? ref(props.rating) : ref(Math.floor(props.rating));
    const missingRating = isFullNumber ? 10 - rating.value : 10 - (rating.value + 1);
    return {
      ratingValue: rating.value,
      isFullNumber,
      missingRating
    }
  }
})
